import React, { ReactNode } from "react";
import { useEffect } from "@wordpress/element";

type SidePanelProps = {
  children?: ReactNode;
  isOpen?: boolean;
  onClose?: () => void;
  sousTitre?: string;
  titre: string;
  width?: string;
};

export default function SidePanel({
  isOpen = false,
  onClose,
  children,
  sousTitre,
  titre,
  width,
}: SidePanelProps) {
  useEffect(() => {
    const html = document.documentElement;

    if (isOpen) {
      const scrollY = window.scrollY;
      document.documentElement.classList.add("fixed-scroll");

      html.style.top = `-${scrollY}px`;
    } else {
      const scrollY = html.style.top;
      document.documentElement.classList.remove("fixed-scroll");

      const prevScrollBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = "auto";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
      html.style.scrollBehavior = prevScrollBehavior || "";
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className={`sidepanel-overlay ${isOpen ? "open" : ""}`}
          onClick={onClose}
        />
      )}

      <div className={`sidepanel sidepanel${isOpen ? "--open" : ""}`}>
        <button
          className="sidepanel__button sidepanel__button--close"
          onClick={onClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
          >
            <path
              d="M10.5 25.5L25.5 10.5M25.5 25.5L10.5 10.5"
              stroke="#222222"
              stroke-width="1.2"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <div className="sidepanel__header">
          <div className="sidepanel__titre">
            <p>{titre}</p>
          </div>
          {sousTitre && (
            <div className="sidepanel__soustitre">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
              >
                <path
                  d="M11.5332 1.33203V14.6654"
                  stroke="black"
                  stroke-width="1.2"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M11.5329 6.46615C12.4534 6.46615 13.1995 5.71995 13.1995 4.79948C13.1995 3.879 12.4534 3.13281 11.5329 3.13281C10.6124 3.13281 9.86621 3.879 9.86621 4.79948C9.86621 5.71995 10.6124 6.46615 11.5329 6.46615Z"
                  fill="black"
                />
                <path
                  d="M2.4668 1.33203V14.6654"
                  stroke="black"
                  stroke-width="1.2"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M2.46647 6.46615C3.38695 6.46615 4.13314 5.71995 4.13314 4.79948C4.13314 3.879 3.38695 3.13281 2.46647 3.13281C1.546 3.13281 0.799805 3.879 0.799805 4.79948C0.799805 5.71995 1.546 6.46615 2.46647 6.46615Z"
                  fill="black"
                />
                <path
                  d="M7 14.6654V1.33203"
                  stroke="black"
                  stroke-width="1.2"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M6.99967 13.5326C7.92015 13.5326 8.66634 12.7864 8.66634 11.8659C8.66634 10.9454 7.92015 10.1992 6.99967 10.1992C6.0792 10.1992 5.33301 10.9454 5.33301 11.8659C5.33301 12.7864 6.0792 13.5326 6.99967 13.5326Z"
                  fill="black"
                />
              </svg>
              <h3>{sousTitre}</h3>
            </div>
          )}
        </div>
        <div className="sidepanel__content">{children}</div>
      </div>
    </>
  );
}
